const days = [
  'Duşenbe',
  'Sişenbe',
  'Çarşenbe',
  'Penşenbe',
  'Anna',
  'Şenbe',
  'Ýekşenbe'
]

export default days



// WEBPACK FOOTER //
// ./src/libraries/days.js